import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const SnapLabelRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.snapLabelList,
    children: [
      { index: true, lazy: () => import('./snap-label-list') },
      { path: ':id', lazy: () => import('./snap-label-detail') },
    ],
  },
];
